function init_lickwindow(from_php){
    var main=$(".place.lickwindow");
    var girl_id=intval(from_php.girl_id);
    
    function initBook(){
        var obj=main.find(".book.girlLickNone");
        obj.one("open",function(){
//            obj.find(".contentWrapJS").myPageSelector({width:700,height:350});
            obj.find(".contentWrap").blankCell();
            obj.find(".cell[data-have='1']").click(function(){
               var th=$(this),g_id=intval(th.attr("data-girl_id"));
               main.find(".book.girlLickConf").bookUse("show",1,g_id);
               return false;
            });
        });
        
    }
    function initBox(){
        var obj=main.find("#lickBox");
//        obj.find(".contentWrapJS").myPageSelector({width:700,height:522});
        obj.find(".contentWrap").blankCell();
       
            
        
    }
    function initConf(){
        var obj=main.find(".book.girlLickConf");
        obj.on("open",function(e,g_id){
            obj.find("#girlNJS").html($.takeGirlNameReal(g_id));
            
            var suit_id=_girlSuitGeneral.takePvPSuitId(g_id);
            var suit_have_obj={};
            if(suit_id){
                suit_have_obj["11"]=suit_id;
            }
            var girlObj=new girlSuitView(g_id,suit_have_obj);
            girlObj.makeView(obj.find(".girl_add"));
            
            suit_id=_girlSuitGeneral.takePvPSuitId(girl_id);
            suit_have_obj={};
            if(suit_id){
                suit_have_obj["11"]=suit_id;
            }
            var girlObj=new girlSuitView(girl_id,suit_have_obj);
            girlObj.makeView(obj.find(".girl_own"));
            obj.find(".addActionJS").attr("action","fight/"+girl_id+"/4/"+g_id);
            
        });
//        obj.bookUse("show",1,13);
    }
    function prepareRewardBox(){
        var box=main.find("#rewardBoxUse");
        if(box.length==0){
            return false;
        }
        var content=box.find(".contentSelector");
        if(box.find(".iconReward").length>5){
            content.addClass("list");
            box.find(".wrapSelectorJS").myPageSelector({height:92,width:469});
            box.find(".contentSelector").blankCell(0,"iconReward blank");
        }
        else{
            content.addClass("static");
        }
        //
        
        //contentSelector
        
    }
    initBox();
    initBook();
    initConf();
    prepareRewardBox();
    
    
     var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px")
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
}